import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { UserAccessRightsGuard } from '../../role/user-role/user-access-rights.guard'
import { AccessRights } from '../../role/user-role/user-role'
import { RouterHistoryLevelGuard } from 'src/app/shared/guards/router-history-level.guard'
import { OrganizationGeneralTabComponent } from '../general-tab/show.component'
import { OrganizationUserRolesTabComponent } from '../user-roles-tab/show.component'
import { OrganizationSaleTabComponent } from '../sale-tab/show.component'
import { OrganizationRequiredSubscriptionTabComponent } from '../required-subscription-tab/show.component'
import { OrganizationDocumentsTabComponent } from '../documents-tab/show.component'
import { OrganizationActivitiesTabComponent } from '../activities-tab/show.component'
import { OrganizationAddressesTabComponent } from '../addresses-tab/show.component'
import { OrganizationBookingTabComponent } from '../booking-tab/booking-tab.component'

const routes: Routes = [
  {
    path: ':organizationId/modal-org/bookings-organization',
    outlet: 'modal',
    canActivate: [RouterHistoryLevelGuard],
    component: OrganizationBookingTabComponent
  },
  {
    path: ':organizationId/modal-org/addresses',
    outlet: 'modal',
    canActivate: [RouterHistoryLevelGuard],
    component: OrganizationAddressesTabComponent
  },
  {
    path: ':organizationId/modal-org/activities',
    outlet: 'modal',
    canActivate: [RouterHistoryLevelGuard],
    component: OrganizationActivitiesTabComponent
  },
  {
    path: ':organizationId/modal-org/documents',
    outlet: 'modal',
    canActivate: [RouterHistoryLevelGuard],
    component: OrganizationDocumentsTabComponent
  },
  {
    path: ':organizationId/modal-org/required-subscriptions',
    outlet: 'modal',
    canActivate: [RouterHistoryLevelGuard],
    component: OrganizationRequiredSubscriptionTabComponent
  },
  {
    path: ':organizationId/modal-org/sales',
    outlet: 'modal',
    canActivate: [RouterHistoryLevelGuard],
    component: OrganizationSaleTabComponent
  },
  {
    path: ':organizationId/modal-org/user-roles',
    outlet: 'modal',
    canActivate: [RouterHistoryLevelGuard],
    component: OrganizationUserRolesTabComponent
  },
  {
    path: ':organizationId/modal-org',
    component: OrganizationGeneralTabComponent,
    outlet: 'modal',
    canActivate: [UserAccessRightsGuard, RouterHistoryLevelGuard],
    data: { accessRights: [AccessRights.Organizations_read] }
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShowModalRoutingModule {}
